
import MessageTick from "../../../assets/filled/MessageTick.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MessageTickIcon({ className, dataTestid = "MessageTickIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MessageTick data-testid={dataTestid} className={classes} {...rest} />
  );
}
